const SPAREKA_OPTIONS_MAPPING = {
  home_appliance_washing_machine: "lave-linge",
  home_appliance_fridge: "réfrigérateur",
  small_home_appliance_vacuum_cleaner: "aspirateur",
  home_appliance_dish_washer: "lave-vaisselle",
  small_home_appliance_blender: "blender",
  small_home_appliance_coffee_maker: "machine à café",
  home_appliance_wine_cellar: "cave à vin",
  small_home_appliance_toaster: "grille-pain",
  home_appliance_extractor: "hotte",
  restroom_bathroom_water_heater: "chauffe-eau",
  home_appliance_tumble_dryer: "sèche-linge",
  home_appliance_freezer: "congélateur",
  small_home_appliance_deep_fryer: "friteuse",
  small_home_appliance_air_conditioner: "climatiseur",
  home_appliance_oven: "four",
  home_appliance_baking_tray: "plaque de cuisson",
  "autre-univers": ["barbecue", "radiateur", "autres"],
};

export { SPAREKA_OPTIONS_MAPPING };
